import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import ServiceCard from '../components/ui/ServiceCard';
import { services } from '../data/services';
import { trackAnalyticsEvent } from '../hooks/useAnalytics';

const ServicesPage = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  const handleContactClick = () => {
    trackAnalyticsEvent('conversion', { 
      event: 'contact_email_click', 
      page: '/services' 
    });
  };

  return (
    <div className="min-h-screen bg-primary-bg pt-20">
      <div className="container mx-auto px-6 py-20">
        
        {/* Header */}
        <motion.div
          className="mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Back Button */}
          <motion.button
            onClick={handleGoBack}
            className="flex items-center space-x-3 text-primary-cyan hover:text-white transition-colors duration-300 mb-8"
            whileHover={{ x: -5 }}
            transition={{ duration: 0.2 }}
          >
            <ArrowLeft size={20} />
            <span>Back to Home</span>
          </motion.button>

          {/* Page Title */}
          <h1 className="text-5xl lg:text-7xl font-display font-bold text-white mb-6">
            All Services
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl leading-relaxed">
            Comprehensive energy forecasting solutions powered by cutting-edge machine learning 
            and deep learning algorithms, designed to optimize your energy operations.
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="space-y-16 lg:space-y-24">
          {services.map((service) => (
            <ServiceCard 
              key={service.id} 
              service={service}
            />
          ))}
        </div>

        {/* Future Services Notice */}
        <motion.div
          className="text-center mt-20 lg:mt-32"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          <div className="glass-morphism rounded-2xl p-8 bg-white/5 max-w-2xl mx-auto">
            <h3 className="text-2xl font-semibold text-white mb-4">
              More Services Coming Soon
            </h3>
            <p className="text-gray-400 leading-relaxed">
              We're continuously expanding our portfolio of energy forecasting solutions. 
              Stay tuned for upcoming services in renewable energy forecasting, grid optimization, 
              and advanced market intelligence.
            </p>
          </div>
        </motion.div>

        {/* Contact CTA */}
        <motion.div
          className="text-center mt-16"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          <div className="glass-morphism rounded-2xl p-6 bg-white/5 inline-block">
            <p className="text-gray-400 mb-4">
              Need a custom solution?
            </p>
            <a 
              href="mailto:marvin@marvinenergy.com"
              onClick={handleContactClick}
              className="text-primary-cyan hover:text-white transition-colors font-medium"
            >
              Contact our team
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ServicesPage;

